module.exports = __webpack_public_path__ + "static/media/Pointer.626d73a3.svg";